if(!customElements.get('bis-modal')) {
  customElements.define(
    'bis-modal',
    class BISModal extends HTMLElement {
      constructor() {
        super();

        this.allVariantsJson = JSON.parse(document.querySelector('[data-bis-display-data]').innerHTML);
        this.klaviyoApiVersion = this.dataset.apiVersion;
        console.log(`Using Klaviyo API revision ${this.klaviyoApiVersion}`);
        this.defaultHeaders = {
          'revision': this.klaviyoApiVersion,
          'accept': 'application/json',
          'content-type': 'application/json'
        };

        this.closeEls = this.querySelectorAll('.bis-modal__close');
        this.alertEls = this.querySelectorAll('.bis-alert');
        this.successEl = this.querySelector('.bis-alert.success');
        this.errorEl = this.querySelector('.bis-alert.error');
        this.errorMap = JSON.parse(this.errorEl.dataset.errorMap);

        this.closeEls.forEach(el => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
          });
        });

        this.addEventListener('keyup', (e) => {
          if(e.code && e.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        this.addEventListener('click', (e) => {
          if(e.target === this) this.hide();
        });

        document.addEventListener('variant:change', this.onVariantChange.bind(this));
      }
      connectedCallback() {
        if(this.moved) return;
        this.moved = true;
        document.body.appendChild(this);

        this.querySelector('.bis-modal__form-container').append(this.querySelector('template').content.cloneNode(true));

        this.selectEl = this.querySelector('select');
        if(this.selectEl) this.selectEl.addEventListener('change', this.onSelectChange.bind(this));
        this.formEl = this.querySelector('form');
        this.formEl.addEventListener('submit', this.handleSubmit.bind(this));
        this.submitBtnEl = this.formEl.querySelector('[type="submit"]');
        this.alertType = this.querySelector('[name="alert_type"]:checked').value;
        this.alertTypeInputEls = this.querySelectorAll('[name="alert_type"]');

        this.alertTypeInputEls.forEach(el => el.addEventListener('change', this.onAlertTypeChange.bind(this)));

        this.iti = window.intlTelInput(this.querySelector('[name="phone"]'), {
          utilsScript: this.dataset.utilsUrl,
          dropdownContainer: document.body,
        });        
      }
      async handleSubmit(e) {
        e.preventDefault();

        this.submitBtnEl.disabled = true;
        this.resetAlerts();
        
        if(this.alertType === 'Text' && !this.validatePhone()) return;

        const formData = new FormData(this.formEl);
        const formApiKey = formData.get('api_key');
        const formId = formData.get('id');
        const formEmail = formData.get('email');
        const formSub = formData.get('subscribe');
        const formPhone = this.alertType === 'Text' && this.iti ? this.iti.getNumber() : false;
        const formListId = formPhone ? formData.get('list_id_sms') : formData.get('list_id_email');

        try {
          const data = {
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: formPhone ? ['SMS'] : ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: formPhone ? null : formEmail,
                      phone_number: formPhone || null
                    }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${formId}`
                  }
                }
              }
            }
          };
          const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${formApiKey}`, {
            method: 'POST',
            headers: this.defaultHeaders,
            body: JSON.stringify(data),
          });

          if(response.ok) {
            if(formSub) {
              try {
                const data = {
                  data: {
                    type: 'subscription',
                    attributes: {
                      profile: {
                        data: {
                          type: 'profile',
                          attributes: {
                            email: formPhone ? null : formEmail,
                            phone_number: formPhone || null
                          }
                        }
                      }
                    },
                    relationships: {list: {data: {type: 'list', id: `${formListId}`}}}
                  }
                };

                const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${formApiKey}`, {
                  method: 'POST',
                  headers: this.defaultHeaders,
                  body: JSON.stringify(data),
                });
              } catch(error) {
                console.error(error);
              }
            }
            this.showAlert(this.successEl);
          } else {
            const errorJson = await response.json();
            const errorText = errorJson.errors[0]?.detail;
            if(errorJson && errorText) {
              this.errorEl.textContent = errorText;
            }
            this.showAlert(this.errorEl);
            console.error(errorJson.errors[0].detail);
          }
        } catch(error) {
          this.showAlert(this.errorEl);
          console.error(error);
        } finally {
          this.submitBtnEl.disabled = false;
        }

      }
      validatePhone() {
        if(!this.iti || this.alertType != 'Text') return;
        
        const inputEl = this.querySelector('input[name="phone"]');

        if(inputEl.value.trim()) {
          if(this.iti.isPossibleNumber()) {
            inputEl.classList.remove('error');
            this.resetAlerts();
            return true;
          } else {
            const errorCode = this.iti.getValidationError();
            const errorMsg = errorCode === -99 ? this.errorMap[0] : this.errorMap[errorCode];
            
            inputEl.classList.add('error');
            this.errorEl.textContent = errorMsg;
            this.showAlert(this.errorEl);
            
            this.submitBtnEl.disabled = false;
            return false;
          }
        }
      }
      show(opener) {
        this.openedBy = opener;
        document.body.classList.add('bis-modal--open');
        this.setAttribute('open', '');
        document.body.dispatchEvent(new CustomEvent('bisModalOpened'));
        trapFocus(this, this.querySelector('[role="dialog"]'));
      }
      hide() {
        document.body.classList.remove('bis-modal--open');
        document.body.dispatchEvent(new CustomEvent('bisModalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        this.resetAlerts();
      }
      onVariantChange(e) {
        if(!this.selectEl || !e.detail?.variant) return;
        if(!this.allVariantsJson.find(el => el.id === e.detail.variant.id)) return;
        
        if(e.detail.variant.inventory_quantity <= 0) {
          this.selectEl.value = e.detail.variant.id;
        }
      }
      onSelectChange(e) {
        this.submitBtnEl.disabled = false;
        this.resetAlerts();
      }
      onAlertTypeChange(e) {
        const activeType = this.querySelector('[name="alert_type"]:checked').value;
        this.alertType = activeType;
        this.querySelectorAll('input[data-alert-type]').forEach(el => {
          el.disabled = el.dataset.alertType === activeType ? false : true;
          el.required = el.dataset.alertType === activeType ? true : false;
        });
        this.resetAlerts();
      }
      resetAlerts() {
        this.alertEls.forEach(el => {
          this.hideAlert(el);
        });
        this.errorEl.textContent = this.errorEl.dataset.original;
      }
      showAlert(el) {
        if(!el) return;

        let newFocusableElement = false;
        el.setAttribute('aria-hidden', false);
        el.querySelectorAll('[focusable="false"]').forEach(el => {
          el.setAttribute('focusable', true);
          el.disabled = false;
          newFocusableElement = true;
        });
        if(newFocusableElement) trapFocus(this, document.activeElement);
      }
      hideAlert(el) {
        if(!el) return;

        let focusableElementRemoved = false;
        el.setAttribute('aria-hidden', true);
        el.querySelectorAll('[focusable="true"]').forEach(el => {
          el.setAttribute('focusable', false);
          el.disabled = true;
          focusableElementRemoved = true;
        });
        if(focusableElementRemoved) trapFocus(this, this.querySelector('[role="dialog"]'));
      }
    }
  );
}
if(!customElements.get('bis-modal-opener')) {
  customElements.define(
    'bis-modal-opener',
    class BISModalOpener extends HTMLElement {
      constructor() {
        super();

        this.buttonEl = this.querySelector('button');
        this.modalEl = document.querySelector(this.dataset.modal);
        this.allVariantsJson = JSON.parse(document.querySelector('[data-bis-display-data]').innerHTML);
        this.hiddenIds = JSON.parse(this.dataset.hiddenVariantIds).map(variantId => parseInt(variantId));

        if(!this.buttonEl || !this.modalEl) return;
        this.buttonEl.addEventListener('click', (e) => {
          this.modalEl.show(this.buttonEl);
        });
        
        document.addEventListener('variant:change', this.onVariantChange.bind(this));
      }
      onVariantChange(e) {
        if(!e.detail?.variant) return;
        if(!this.allVariantsJson.find(el => el.id === e.detail.variant.id)) return;
        this.classList.toggle('hide', e.detail.variant.inventory_quantity > 0 || this.hiddenIds.includes(e.detail.variant.id));
      }
      disconnectedCallback() {
        this.modalEl.remove();
      }
    }
  );
}
